<template>
  <div class="consultoria-card" :class="{ 'collapsed': isCollapsed }">
    <div class="consultoria-card__inner">
      <div class="consultoria-card__icon-wrap">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013 5.18 2 2 0 015 3h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L9.09 10.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 18v1.92z"/>
        </svg>
      </div>
      <div class="consultoria-card__content">
        <p class="consultoria-card__label">Precisa de ajuda?</p>
        <p class="consultoria-card__sub">Fale com nosso time</p>
      </div>
      <button class="consultoria-card__btn" @click="abrirConsultoria" title="Agendar consultoria">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"/>
          <polyline points="12 5 19 12 12 19"/>
        </svg>
      </button>
    </div>
    <button class="consultoria-card__icon-only" @click="abrirConsultoria" title="Agendar consultoria">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013 5.18 2 2 0 015 3h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L9.09 10.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 18v1.92z"/>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ConsultoriaCard',
  props: {
    isCollapsed: {
      type: Boolean,
      default: false,
    },
    bookingUrl: {
      type: String,
      default: 'https://iaqfaz.com.br/agendar/dkp-consultoria-cd8d/consultoria-vsl-booster',
    },
  },
  methods: {
    abrirConsultoria() {
      window.open(this.bookingUrl, '_blank', 'noopener,noreferrer')
    },
  },
}
</script>

<style scoped>
.consultoria-card {
  padding: 12px 16px 16px;
  flex-shrink: 0;
}

.consultoria-card__inner {
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, rgba(232, 106, 16, 0.14) 0%, rgba(232, 106, 16, 0.06) 100%);
  border: 1px solid rgba(232, 106, 16, 0.22);
  border-radius: 10px;
  padding: 11px 12px;
  transition: background 0.2s ease, border-color 0.2s ease;
  cursor: default;
}

.consultoria-card__inner:hover {
  background: linear-gradient(135deg, rgba(232, 106, 16, 0.22) 0%, rgba(232, 106, 16, 0.10) 100%);
  border-color: rgba(232, 106, 16, 0.38);
}

.consultoria-card__icon-wrap {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  background: rgba(232, 106, 16, 0.18);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #E86A10;
}

.consultoria-card__content {
  flex: 1;
  min-width: 0;
}

.consultoria-card__label {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 600;
  color: #fff;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.consultoria-card__sub {
  margin: 2px 0 0;
  font-size: 0.68rem;
  color: rgba(201, 216, 232, 0.55);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.consultoria-card__btn {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  background: #E86A10;
  border: none;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  transition: background 0.18s ease, transform 0.15s ease;
  outline: none;
}

.consultoria-card__btn:hover {
  background: #D25E0D;
  transform: translateX(2px);
}

.consultoria-card__icon-only {
  display: none;
  width: 40px;
  height: 40px;
  background: rgba(232, 106, 16, 0.18);
  border: 1px solid rgba(232, 106, 16, 0.25);
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  color: #E86A10;
  cursor: pointer;
  margin: 0 auto;
  transition: background 0.2s ease;
  outline: none;
}

.consultoria-card__icon-only:hover {
  background: rgba(232, 106, 16, 0.3);
}

/* Estado colapsado */
.consultoria-card.collapsed .consultoria-card__inner {
  display: none;
}

.consultoria-card.collapsed .consultoria-card__icon-only {
  display: flex;
}
</style>
